/**
 * Does the operator have the Web Chat Widget feature? Mirrors the backend's
 * `web_widget_available` (demo/lib/web_widget_access.py): `web_chat_widget_available` unset
 * means available since 2026-10-19 -- who sees the page is RBAC (`web_widget.read`, implied
 * by full access). Only an explicit `false`, set by TourOptima staff, turns it off. The
 * public widget still needs the operator's own live switch (`web_chat_widget_enabled`).
 */
export const isWebWidgetAvailable = (tourOperator) => {
  if (!tourOperator) return false;
  const value = tourOperator.config ? tourOperator.config.web_chat_widget_available : undefined;
  return value === undefined || value === null ? true : !!value;
};

export default isWebWidgetAvailable;
